// extracted by mini-css-extract-plugin
export default {"text":"About_text__+oV2n","skillContainer":"About_skillContainer__ltuKV","skillsSection":"About_skillsSection__4SpHs","skillDescription":"About_skillDescription__tmDNm"};